import { cva } from "class-variance-authority";
import { cn } from "@/lib/utils";
import { Button } from "../ui/button";

export default function FilterButton({
    position,
    className,
    ...props
}: React.ComponentProps<"button"> & {
    position: "left" | "middle" | "right";
}) {
    const buttonVariants = cva(
        "rounded-none border-r-border/60 border-r px-2 text-sm font-normal bg-white h-7 outline-none focus-visible:ring-0 select-none",
        {
            variants: {
                position: {
                    left: "rounded-l-md",
                    middle: "",
                    right: "rounded-r-md border-r-0",
                },
            },
            defaultVariants: {
                position: "middle",
            },
        }
    );
    return <Button className={cn(buttonVariants({ position }), className)} variant="ghost" size="sm" {...props} />;
}
